import type { BlogOutline, BlogRefresh } from '@/services/DataService';

/**
 * How often /ui/blogs re-reads statuses, matching the old per-agent Output
 * screens' 15s polling.
 */
export const LIVE_STATUS_POLL_MS = 15_000;

/**
 * Whether any refresh attempt in a blog's history is still running.
 *
 * @param refreshes - The blog's refresh attempts.
 *
 * @returns Whether one is running.
 */
export function isAnyRefreshRunning (refreshes: BlogRefresh[] = []): boolean {
  return refreshes.some((refresh) => {
    return refresh.status === 'IN_PROGRESS';
  });
}

/**
 * Whether any outline attempt in a blog's history is still running, including
 * a draft being written for an approved outline.
 *
 * @param outlines - The blog's outline attempts.
 *
 * @returns Whether one is running.
 */
export function isAnyOutlineRunning (outlines: BlogOutline[] = []): boolean {
  return outlines.some((outline) => {
    return outline.status === 'GENERATING_DRAFT' || outline.metadata?.draft_status === 'IN_PROGRESS';
  });
}

/**
 * The refetch interval for a live-status query: poll while running, stop once settled.
 *
 * @param running - Whether anything the query shows is still running.
 *
 * @returns The interval in ms, or false to stop polling.
 */
export function pollWhileRunning (running: boolean): number | false {
  return running ? LIVE_STATUS_POLL_MS : false;
}
